import React, { useCallback, useContext, useState, useEffect } from 'react'
import { Fade, Paper, Stack, Chip } from '@mui/material'
import InputSearch from '../../components/InputSearch.jsx'
import { useParams } from 'react-router-dom'
import { useStoreState } from 'pullstate'
import { AppStore } from '../../stores/AppStore.js'

const PeopleBuilderPersonalFilter = ({ openFilter, setFilteredPeopleBuilder, filteredPeopleBuilder }) => {
    const { userId } = useParams()
    const { peopleBuilders } = useStoreState(AppStore)
    const [year, setYear] = useState('')
    const [years, setYears] = useState([])
    const userLogged = useStoreState(AppStore, s => s.user)

    const handlePersonalFilter = useCallback((year) => {

        let filtered = peopleBuilders.filter(user => (user?.year === parseInt(year) || !year) && (user?.player_id === userId || user?.player_id === userLogged.id))
        filtered.sort((a, b) => a.player.full_name.localeCompare(b.player.full_name))

        setFilteredPeopleBuilder(filtered)
    }, [])

    useEffect(() => {
        const years = []
        const getYears = []
        // const pbFiltered = peopleBuilders.filter(user => user.pb_settings.status !== 'previous')
        peopleBuilders.map((user, index) => {
            if (!years.includes(user.year.toString())) {
                getYears.push({ label: user.year.toString(), id: index })
            }
            years.push(user.year.toString())
        })
        setYears(getYears)
    }, [peopleBuilders])

    const getChip = () => {
        if (year) {
            return (
                <>
                    <Chip label="Filtered" variant="filled" color='info' />
                    <Chip label={filteredPeopleBuilder.length} variant="filled" color='info' />
                </>
            )
        }
    }

    return (
        <>
            <Fade in={openFilter} timeout={500}>
                <Paper elevation={2} sx={{  p: 2, mb:1, borderRadius: 0 }}>
                    <Stack direction='row' gap={2} alignItems='center'>
                        <InputSearch
                            list={years}
                            sizeProp={200}
                            // value={year}
                            value={years.find(y => y.label === year) || null}
                            onChange={(e, value) => {
                                handlePersonalFilter(value?.label)
                                setYear(value?.label)
                            }}
                            label='Year'
                        />
                        {getChip()}
                    </Stack>
                </Paper>
            </Fade>

        </>
    )
}

export default PeopleBuilderPersonalFilter